/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React, { useState } from 'react'
import { Form, Input, Button, Row, Col, Alert } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import AuthenticationService from '../../services/authenticationService'
import { useNavigate } from 'react-router-dom'
import logo from '../../public/img/logo.svg'
import './Login.module.scss'

const Login = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [isLoginError, setIsLoginError] = useState(false)
	const [isAuthDone, setIsAuthDone] = useState(false)
	const navigate = useNavigate()

	const handleSubmit = (e: any) => {
		try {
			setIsLoading(true)
			AuthenticationService.login(e.email, e.password)
				.then((result) => {
					// console.log(result)
					if (result && result.id) {
						navigate('/')
					} else {
						// No Login Found
						setIsLoginError(true)
					}
				})
				.catch((err) => {
					console.error(err)
				})
				.finally(() => {
					setIsAuthDone(true)
					setIsLoading(false)
				})
		} catch (error) {
			console.error(error)
		}
	}

	const LoginForm = () => {
		return (
			<Form onFinish={handleSubmit}>
				<Form.Item
					name="email"
					rules={[
						{
							required: true,
							message: 'Please enter your Email',
						},
					]}
					validateStatus={isLoginError ? 'error' : null}
					required
				>
					<Input
						prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
						type="email"
						placeholder="Email"
						autoComplete="username"
					/>
				</Form.Item>
				<Form.Item
					name="password"
					rules={[
						{
							required: true,
							message: 'Password is required',
						},
					]}
					validateStatus={isLoginError ? 'error' : null}
					required
				>
					<Input
						prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
						type="password"
						placeholder="password"
						autoComplete="current-password"
					/>
				</Form.Item>
				<div style={{ textAlign: 'right' }}>
					<Button
						type="link"
						onClick={() => navigate('/forgotpassword')}
					>
						Forgot Password?
					</Button>
				</div>
				<Form.Item>
					<Button
						block
						type="primary"
						htmlType="submit"
						loading={isLoading}
						size="large"
					>
						Login
					</Button>
				</Form.Item>
				<div
					style={{
						borderRadius: '10px',
						padding: '12px',
						backgroundColor: '#f7f7f8',
						color: '#86859b',
						textAlign: 'center',
						fontSize: '14px',
						letterSpacing: '0.5px',
					}}
				>
          "For the best experience, we recommend Google Chrome, Mozilla Firefox or Apple Safari"
				</div>
			</Form>
		)
	}

	return (
		<div className="whiteBgPage">
			<Row
				type="flex"
				align="middle"
				justify="center"
				style={{ padding: '1rem' }}
			>
				<Col xs={24} md={8}>
					<img src={logo} alt="Logo" style={{ padding: '20px 0' }} />
					{isAuthDone && isLoginError && (
						<Alert
							message={'Invalid Email/Password'}
							type="error"
							style={{ margin: '1rem 0' }}
						/>
					)}
					<LoginForm />
				</Col>
			</Row>
		</div>
	)
}

export default Login
